export default function (responsaveis: string[]): any {
  return {
    or: [
      {
        responsavelNegocialCodigo: {
          in: responsaveis,
        },
      },
      {
        responsavelProcessualCodigo: {
          in: responsaveis,
        },
      },
    ],
  };
}
